var render = function render(){var _vm=this,_c=_vm._self._c;return _c('loading',{staticClass:"custom-loading-dash",attrs:{"active":_vm.isDashLoading,"can-cancel":false,"color":'#f18f00',"is-full-page":false,"height":100,"width":255,"opacity":0.8},on:{"update:active":function($event){_vm.isDashLoading=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }